import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';

const DeleteContentModal = ({
  onClickNo = null,
  onClickYes = null,
  text = null,
  onClose = null,
}) => {
  const handleClickNo = (event) => {
    if (onClickNo) {
      onClickNo(event);
    }
    onClose();
  };

  const handleClickYes = (event) => {
    if (onClickYes) {
      onClickYes(event);
    }
    onClose();
  };

  return (
    <ModalWithTemplate
      header={text || I18n.t('web.destroy_modal.text')}
      onCloseModal={onClose}
    >
      <Box justifyContent="flex-end" width="100%">
        <Button variant="secondary" onClick={handleClickNo} mr={4}>
          {I18n.t('_no')}
        </Button>
        <Button variant="primary" onClick={handleClickYes}>
          {I18n.t('_yes')}
        </Button>
      </Box>
    </ModalWithTemplate>
  );
};

DeleteContentModal.propTypes = {
  onClickNo: PropTypes.func,
  onClickYes: PropTypes.func,
  onClose: PropTypes.func,
  text: PropTypes.string,
};

export default DeleteContentModal;
